import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Accordion, AccordionItem, Collapse } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import CountUp from "react-countup";
import SimpleBar from "simplebar-react";
import ModalImage from "react-modal-image";
import { api } from "../../../config";

// Formik
import { useSelector, useDispatch } from "react-redux";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { addNewAccTrans as onAddNewAccTrans, getAccTrans, updateAccTrans as onUpdateAccTrans, getAccTransLoading } from "../../../store/accTrans/action";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Purchase = () => {
  const printRef = useRef(null);
  const expanseDataRef = useRef([]);
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, companies, vendors, vendorLoading, branches, branchLoading, civilBudgets, civilBudgetLoading, departments, departmentLoading, accTranss, accTransAdded, isAccTransCreated, isAccTransSuccess, accTransloading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    companies: state.Company.companies,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    accTranss: state.AccTrans.accTranss,
    accTransAdded: state.AccTrans.accTransAdded,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    accTransloading: state.AccTrans.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchaseListAll, setPurchaseListAll] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);
  const [info, setInfo] = useState([]);
  const [expense, setExpense] = useState([]);
  const [label, setLabel] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [logList, setLogList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchBudget, setSearchBudget] = useState("");
  const [searchDepartment, setSearchDepartment] = useState(null);
  const [departmentSelect, setDepartmentSelect] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetTypeList, setCivilBudgetTypeList] = useState([]);

  const [printMaterialDoc, setPrintMaterialDoc] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  useEffect(() => {
    let dataDoc = [
      {
        id: "supplier",
        label: "Kontak / Supplier",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "No Invoice",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "total",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "supplier");
          doc.data.push(label);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transaction_reff");
          doc.data.push(data?.transaction_reff);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "dueat");
          doc.data.push(data?.dueat ? handleValidDate(data?.dueat) : handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "total");
          doc.data.push(data?.total);

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintMaterialDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "supplier",
        label: "Kontak / Supplier",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis Hutang",
        isSelected: true,
        data: [],
      },
      {
        id: "total",
        label: "Total",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((purchase) => {
        if (purchase.isChecked) {
          Object.entries(purchase).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              doc.data.push(value);
            }
          });
        }
      });
    }
    setPrintDoc(dataDoc);
  }, [purchaseList]);

  const handleGetPayable = (id, branchId) => {
    dispatch(getAccTrans({ expense: true, companyId: id, branchId: branchId, date: "all" }));
    setBranchIdSelected(branchId);
    handleGetCivilBudget(id, branchId);
    handleGetDepartement(id);
    handleGetVendor(id);
  };

  const handleGetVendor = (companyId) => {
    dispatch(resetVendorState());
    dispatch(getVendor({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [{ label: "SEMUA DEPT.", value: "" }];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilTypeData = [{ label: "SEMUA ANGGARAN", value: "all" }, { label: "NON RAB", value: "none" }];
      var opt = [];
      var optType = [];
      civilBudgets
        .filter((f) => f.type === "BANGUNAN" || f.type === "INFRASTRUKTUR" || f.type === "PEKERJAAN TAMBAH 1" || f.type === "PEKERJAAN TAMBAH 2" || f.type === "PEKERJAAN TAMBAH 3" || f.type === "PEKERJAAN TAMBAH 4" || f.type === "PEKERJAAN TAMBAH 5" || f.type === "PEKERJAAN TAMBAH 6" || f.type === "PEKERJAAN TAMBAH 7" || f.type === "PEKERJAAN TAMBAH 8" || f.type === "LISTRIK JARINGAN")
        .forEach((it, idx) => {
          const type = it.type ? it.type : "";
          const typeName = it.name ? it.name : "";
          if (branchIdSelected === it.branchId) {
            const budgetId = it.id ? it.id : "";
            it.cvl_detail.forEach((item, key) => {
              const name = item?.cvld_account?.name;
              const id = item?.cvld_account?.id;
              opt.push({ label: type + " - " + name, cvl_account: name, value: budgetId, type: type, civilBudgetId: budgetId, civilBudgetDetailId: item.id, civilAccountId: id, material: item.cvld_material });
            });
          }
          optType.push({ label: typeName, value: it.id });
        });
      var option = { options: opt };
      var option_type = { options: optType };
      civilBudgetData.push(option);
      civilTypeData.push(option_type);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetTypeList(civilTypeData);
    } else {
      setCivilBudgetTypeList([]);
      setCivilBudgetList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  const toggleTab = (tab, type) => {
    let filteredAccTrans = searchDepartment?.value ? accTranss.filter((f) => f?.departmentId === searchDepartment?.value) : accTranss;

    if (type === "budget" && tab !== "all") {
      let arrOther = [];
      if (tab === "none") {
        let trans = JSON.parse(JSON.stringify(accTranss));
        trans.forEach((e) => {
          let hasRab = false;
          let hasPurchaseold = (e?.at_purchase?.purchase_detail || []).filter((f) => !f?.civilBudgetId).length ? true : false;
          if (e?.at_rls?.length > 0) {
            let amount = 0;
            for (const f of (e?.at_rls || [])) {
              if (f?.at_rls_purchase?.purchase_detail?.find((ff) => !ff.civilBudgetId ) || !f?.at_rls_contract?.civilBudgetId || !f?.at_rls_trx?.civilBudgetId) {
                amount += parseFloat(f?.amount || 0);
                hasRab = true;
              }
            }
            e.amount = amount;
          }

          if (!e.civilBudgetId || hasRab || hasPurchaseold) arrOther.push(e);
        });
      }
      else {
        let trans = JSON.parse(JSON.stringify(accTranss));
        trans.forEach((e) => {
          let hasRab = false;
          let hasPurchaseold = (e?.at_purchase?.purchase_detail || []).filter((f) => f?.civilBudgetId === tab).length ? true : false;
          if (e?.at_rls?.length > 0) {
            let amount = 0;
            for (const f of (e?.at_rls || [])) {
              if (f?.at_rls_purchase?.purchase_detail?.find((ff) => ff.civilBudgetId === tab) || f?.at_rls_contract?.civilBudgetId === tab || f?.at_rls_trx?.civilBudgetId === tab) {
                amount += parseFloat(f?.amount || 0);
                hasRab = true;
              }
            }
            e.amount = amount;
          }

          if (e.civilBudgetId === tab || hasRab || hasPurchaseold) arrOther.push(e);
        });
      }

      filteredAccTrans = arrOther;
    }

    setActiveTab(tab);
    let arr = [];
    let arrLog = [];
    for (const data of filteredAccTrans.filter((f) => f.statusId === 3)) {
      let tag = "";
      if (data.legalId || data.legalPermissionId || data.legalFractionalId || data.legalMasterId || data?.at_tag?.type === "PERTANAHAN") {
        tag = "PERTANAHAN";
      }
      else if (data?.civilBudgetId || data?.civilBudgetDetailId || data?.at_purchase?.purchase_detail[0]?.civilBudgetId || data?.at_cvl_contract?.civilBudgetId || data?.at_rls[0]?.at_rls_purchase?.purchase_detail[0]?.civilBudgetId || data?.at_rls[0]?.at_rls_contract?.civilBudgetId || data?.at_rls[0]?.at_rls_trx?.civilBudgetId) {
        tag = "TEKNIK";
      }
      else if (data?.at_tag?.type === "OPERASIONAL" || (data?.at_rls?.length > 0 && data?.at_rls[0]?.at_rls_trx?.type === "OPERASIONAL")) {
        tag = "OPERASIONAL";
      }
      else if (data?.salesId || data?.at_tag?.type === "UMUM" || (data?.at_rls?.length > 0 && data?.at_rls[0]?.at_rls_trx?.type === "UMUM")) {
        tag = "UMUM";
      }
      else {
        tag = "LAIN-LAIN";
      }

      let name = data?.at_user?.name || "NO NAME";
      let supplier = arr.find((d) => d.name === name && d.tag === tag);
      let amount = parseFloat(data.amount || 0);

      const payable = data?.at_rls?.length > 0 || data?.accTransPaymentId || data?.purchaseId || data?.civilContractId ? amount : 0;
      const cash = data?.at_rls?.length > 0 || data?.accTransPaymentId || data?.purchaseId || data?.civilContractId ? 0 : amount;
      const total = amount;
      arrLog.push(data.id)

      if (supplier) {
        let ttl = supplier.total + total;
        let ttl_payable = supplier.payable + payable;
        let ttl_cash = supplier.cash + cash;
        supplier.total = ttl;
        supplier.payable = ttl_payable;
        supplier.cash = ttl_cash;
        supplier.tag = tag;
        supplier.realization = [...supplier.realization, data];
        supplier.detail.push({
          id: data?.id,
          tag: tag,
          departmentId: data?.departmentId,
          rab: data.civilBudgetId ? data?.at_budget?.type : "",
          branch: data?.at_branch?.branch_code,
          type: data?.at_rls && data?.at_rls[0]?.type ? data?.at_rls[0]?.type : "-",
          civilContractId: null,
          purchaseId: null,
          userId: data?.at_user?.id || null,
          vendorId: null,
          transaction_no: data?.transaction_no,
          transactionat: data?.transactionat,
          dueat: data?.transactionat,
          transaction_reff: data?.transaction_reff,
          description: data?.description,
          supplier: data?.at_user?.name + ' - ' + tag,
          name: data?.at_user?.name,
          file: data?.at_file,
          total: total,
        });
      } else {
        arr.push({
          id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
          branch: data?.at_branch?.branch_code,
          supplier: data?.at_user?.name + ' - ' + tag,
          name: name,
          total: total,
          payable: payable,
          cash: cash,
          tag: tag,
          realization: [data, ...(data.at_payment_detail ? data.at_payment_detail : [])],
          detail: [
            {
              id: data?.id,
              departmentId: data?.departmentId,
              rab: data.civilBudgetId ? data?.at_budget?.type : "",
              branch: data?.at_branch?.branch_code,
              civilContractId: null,
              purchaseId: null,
              type: data?.at_rls && data?.at_rls[0]?.type ? data?.at_rls[0]?.type : "-",
              userId: data?.at_user?.id || null,
              vendorId: null,
              transaction_no: data?.transaction_no,
              transactionat: data?.transactionat,
              dueat: data?.transactionat,
              transaction_reff: data?.transaction_reff,
              description: data?.description,
              supplier: data?.at_user?.name + ' - ' + tag,
              name: data?.at_user?.name,
              file: data?.at_file,
              total: total,
            },
          ],
        });

      }
    }

    setPurchaseListAll(arr);
    if (tab === "all") {
      setPurchaseList(arr.map((el) => ({ ...el, isChecked: false })));
    }
    else {
      if (tab !== "all" && type !== "budget") {
        setPurchaseList(arr.filter(f => f.tag === tab).map((el) => ({ ...el, isChecked: false })));
      }
      else {
        setPurchaseList(arr.map((el) => ({ ...el, isChecked: false })));
      }
    }
    setLogList(arrLog);
  };

  useEffect(() => {
    let filteredAccTrans = searchDepartment?.value ? accTranss.filter((f) => f?.departmentId === searchDepartment?.value) : accTranss;
    let arrLog = [];
    let arr = [];
    for (const data of filteredAccTrans.filter((f) => f.statusId === 3)) {
      let tag = "";
      if (data.legalId || data.legalPermissionId || data.legalFractionalId || data.legalMasterId || data?.at_tag?.type === "PERTANAHAN") {
        tag = "PERTANAHAN";
      }
      else if (data?.civilBudgetId || data?.civilBudgetDetailId || data?.at_purchase?.purchase_detail[0]?.civilBudgetId || data?.at_cvl_contract?.civilBudgetId || data?.at_rls[0]?.at_rls_purchase?.purchase_detail[0]?.civilBudgetId || data?.at_rls[0]?.at_rls_contract?.civilBudgetId || data?.at_rls[0]?.at_rls_trx?.civilBudgetId) {
        tag = "TEKNIK";
      }
      else if (data?.at_tag?.type === "OPERASIONAL" || (data?.at_rls?.length > 0 && data?.at_rls[0]?.at_rls_trx?.type === "OPERASIONAL")) {
        tag = "OPERASIONAL";
      }
      else if (data?.salesId || data?.at_tag?.type === "UMUM" || (data?.at_rls?.length > 0 && data?.at_rls[0]?.at_rls_trx?.type === "UMUM")) {
        tag = "UMUM";
      }
      else {
        tag = "LAIN-LAIN";
      }

      let name = data?.at_user?.name || "NO NAME";
      let supplier = arr.find((d) => d.name === name && d.tag === tag);

      let amount = parseFloat(data.amount || 0);

      const payable = data?.at_rls?.length > 0 || data?.accTransPaymentId || data?.purchaseId || data?.civilContractId ? amount : 0;
      const cash = data?.at_rls?.length > 0 || data?.accTransPaymentId || data?.purchaseId || data?.civilContractId ? 0 : amount;
      const total = amount;

      if (payable > 0) {
        arrLog.push(data.id);
      }

      if (data?.at_user?.name === "UMPD STW")
        console.log(data);

      if (supplier) {
        let ttl = supplier.total + total;
        let ttl_payable = supplier.payable + payable;
        let ttl_cash = supplier.cash + cash;
        supplier.total = ttl;
        supplier.payable = ttl_payable;
        supplier.cash = ttl_cash;
        supplier.tag = tag;
        supplier.realization = [...supplier.realization, data];
        supplier.detail.push({
          id: data?.id,
          departmentId: data?.departmentId,
          rab: data.civilBudgetId ? data?.at_budget?.type : "",
          type: data?.at_rls && data?.at_rls[0]?.type ? data?.at_rls[0]?.type : "-",
          branch: data?.at_branch?.branch_code,
          civilContractId: null,
          purchaseId: null,
          userId: data?.at_user?.id || null,
          vendorId: null,
          transaction_no: data?.transaction_no,
          transactionat: data?.transactionat,
          dueat: data?.transactionat,
          transaction_reff: data?.transaction_reff,
          description: data?.description,
          name: data?.at_user?.name,
          supplier: data?.at_user?.name + ' - ' + tag,
          file: data?.at_file,
          total: total,
        });
      } else {
        arr.push({
          id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
          type: data?.at_rls && data?.at_rls[0]?.type ? data?.at_rls[0]?.type : "-",
          branch: data?.at_branch?.branch_code,
          name: name,
          supplier: data?.at_user?.name + ' - ' + tag,
          tag: tag,
          total: total,
          payable: payable,
          cash: cash,
          realization: [data],
          detail: [
            {
              id: data?.id,
              departmentId: data?.departmentId,
              rab: data.civilBudgetId ? data?.at_budget?.type : "",
              type: data?.at_rls && data?.at_rls[0]?.type ? data?.at_rls[0]?.type : "",
              branch: data?.at_branch?.branch_code,
              civilContractId: null,
              purchaseId: null,
              userId: data?.at_user?.id || null,
              vendorId: null,
              transaction_no: data?.transaction_no,
              transactionat: data?.transactionat,
              dueat: data?.transactionat,
              transaction_reff: data?.transaction_reff,
              description: data?.description,
              name: data?.at_user?.name,
              supplier: data?.at_user?.name + ' - ' + tag,
              file: data?.at_file,
              total: total,
            },
          ],
        });
      }
    }

    setLogList(arrLog);
    setPurchaseListAll(arr);
    setPurchaseList(arr.map((el) => ({ ...el, isChecked: false })));
    setInfo(arr[arr.length - 1]);
  }, [accTranss, searchDepartment]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input
              type="checkbox"
              className="dataCheckbox me-2 form-check-input"
              checked={data.isChecked}
              onChange={() => {
                const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                setPurchaseList(updatedData);
              }}
            />
          </div>
        );
      },
    },
    {
      Header: "Kontak / Supplier",
      accessor: "name",
      filterable: true,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div
            className="cursor-pointer text-primary fw-semibold"
            onClick={() => {
              expanseDataRef.current = data.detail;
              setLabel(data.name);
              setExpense(data.detail);
              setModalDetail(true);
            }}
          >
            {data.name}
          </div>
        );
      },
    },
    {
      Header: "Jenis",
      accessor: "tag",
      filterable: true,
    },
    {
      id: "MenungguInv",
      Header: <div className="pe-3">Jumlah Transaksi</div>,
      accessor: "invoice_non_amount",
      filterable: true,
      Cell: (cellProps) => {
        const data = cellProps.row.original;
        return (
          <div
            className="cursor-pointer text-primary fw-semibold"
            onClick={() => {
              expanseDataRef.current = data.detail;
              setLabel(data.name);
              setExpense(data.detail);
              setModalDetail(true);
            }}>
            {data?.detail?.length} Transaksi
          </div>
        );
      },
    },
    {
      Header: "Pembayaran Hutang",
      accessor: "payable",
      filterable: true,
      Cell: (cellProps) => {
        const data = cellProps.row.original;
        return (
          <div
            className="cursor-pointer text-info fw-semibold"
            onClick={() => {
              expanseDataRef.current = data.realization;
              setInfo(data);
              setExpense(data.realization || []);
              toggle();
            }}
          >
            {currencyFormat(data.payable === null ? 0 : data.payable)}
          </div>
        );
      },
    },
    {
      Header: "Pembayaran Non Hutang",
      accessor: "cash",
      filterable: true,
      Cell: (cellProps) => {
        const data = cellProps.row.original;
        return (
          <div
            className="cursor-pointer text-success fw-semibold"
            onClick={() => {
              expanseDataRef.current = data.realization;
              setInfo(data);
              setExpense(data.realization || []);
              toggle();
            }}
          >
            {currencyFormat(data.cash === null ? 0 : data.cash)}
          </div>
        );
      },
    },
    {
      Header: "Total Pembayaran",
      accessor: "total",
      filterable: true,
      Cell: (cellProps) => {
        const data = cellProps.row.original;
        return (
          <div
            className="cursor-pointer text-primary fw-semibold"
            onClick={() => {
              expanseDataRef.current = data.realization;
              setInfo(data);
              setExpense(data.realization || []);
              toggle();
            }}
          >
            {currencyFormat(data.total === null ? 0 : data.total)}
          </div>
        );
      },
    },
  ], [purchaseList, userRole, userType, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Keterangan", "UmurHutang", "UangMuka"],
        pageIndex: pageIdx,
        pageSize: 500,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    var status = statusPurchase.value ? statusPurchase.value : "";
    if (filterDate) {
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
        const param = {
          title: searchValue,
          startat: startat,
          endat: endat,
          status: status,
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          expense: true,
        };
        dispatch(getAccTrans(param));
      } else {
        const param = {
          title: searchValue,
          status: status,
          date: "all",
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          expense: true,
        };
        dispatch(getAccTrans(param));
      }
    } else {
      const param = {
        title: searchValue,
        status: status,
        date: "all",
        departmentId: searchDepartment?.value ?? "",
        branchId: branchSelected?.value ?? "",
        companyId: companySelected?.value ?? "",
        typeId: 1,
        expense: true,
      };
      dispatch(getAccTrans(param));
    }
  }

  function handleResetFilter() {
    setSearchBudget("");
    setFilterDate(null);
    setStatusPurchase([]);
    setSearchDepartment("");
    setSearchValue("");
    setInfo({});
    handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
  }

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el.transaction_reff ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.supplier ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          ((el.total || 0).toString() ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.branch ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };


  useEffect(() => {
    if (branchSelected && companySelected) {
      setInfo({});
      handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  document.title = "Penggunaan Dana | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Penggunaan Dana" loading={accTransloading}>
          <div className="flex-shrink-0">
            <ExportDoc data={printDoc} />
            {/* <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>  */}
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col style={{ width: `${100 / 5}%` }}>
            <Card className="card-animate cursor-pointer" style={activeTab === "all" ? { borderBottom: "3px solid #FFCC00" } : { borderBottom: "2px solid #CCCCCC" }} onClick={() => {
              toggleTab("all");
              gotoPage(0);
              setPageIdx(0);
            }}>
              <CardBody className="pt-3 pb-3">
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <h4 className="fs-20 fw-semibold ff-secondary mb-1">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseListAll || []).reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(purchaseListAll || []).length}</span>
                    <span className="text-muted">Semua Transaksi</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col style={{ width: `${100 / 5}%` }}>
            <Card className="card-animate cursor-pointer" style={activeTab === "TEKNIK" ? { borderBottom: "3px solid #FFCC00" } : { borderBottom: "2px solid #CCCCCC" }} onClick={() => {
              toggleTab("TEKNIK");
              gotoPage(0);
              setPageIdx(0);
            }}>
              <CardBody className="pt-3 pb-3">
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <h4 className="fs-20 fw-semibold ff-secondary mb-1">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseListAll || []).filter(f => f.tag === 'TEKNIK').reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(purchaseListAll || []).filter(f => f.tag === 'TEKNIK').length}</span>
                    <span className="text-muted">Teknik</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col style={{ width: `${100 / 5}%` }}>
            <Card className="card-animate cursor-pointer" style={activeTab === "PERTANAHAN" ? { borderBottom: "3px solid #FFCC00" } : { borderBottom: "2px solid #CCCCCC" }} onClick={() => {
              toggleTab("PERTANAHAN");
              gotoPage(0);
              setPageIdx(0);
            }}>
              <CardBody className="pt-3 pb-3">
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <h4 className="fs-20 fw-semibold ff-secondary mb-1">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseListAll || []).filter(f => f.tag === "PERTANAHAN").reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(purchaseListAll || []).filter(f => f.tag === "PERTANAHAN").length}</span>
                    <span className="text-muted">Pertanahan</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col style={{ width: `${100 / 5}%` }}>
            <Card className="card-animate cursor-pointer" style={activeTab === "OPERASIONAL" ? { borderBottom: "3px solid #FFCC00" } : { borderBottom: "2px solid #CCCCCC" }} onClick={() => {
              toggleTab("OPERASIONAL");
              gotoPage(0);
              setPageIdx(0);
            }}>
              <CardBody className="pt-3 pb-3">
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <h4 className="fs-20 fw-semibold ff-secondary mb-1">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseListAll || []).filter(f => f.tag === "OPERASIONAL").reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(purchaseListAll || []).filter(f => f.tag === "OPERASIONAL").length}</span>
                    <span className="text-muted">Operasional</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col style={{ width: `${100 / 5}%` }}>
            <Card className="card-animate cursor-pointer" style={activeTab === "UMUM" ? { borderBottom: "3px solid #FFCC00" } : { borderBottom: "2px solid #CCCCCC" }} onClick={() => {
              toggleTab("UMUM");
              gotoPage(0);
              setPageIdx(0);
            }}>
              <CardBody className="pt-3 pb-3">
                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <h4 className="fs-20 fw-semibold ff-secondary mb-1">
                      <CountUp start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseListAll || []).filter(f => f.tag === "UMUM").reduce((a, v) => (a = a + parseFloat(v.total || 0)), 0)}
                        duration={1}
                        className="counter-value" />
                    </h4>
                    <span className="badge bg-info me-2">{(purchaseListAll || []).filter(f => f.tag === "UMUM").length}</span>
                    <span className="text-muted">Umum</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                {/* {JSON.stringify(logList).replace("[", "").replace("]", "")} */}
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchDepartment"
                            value={searchDepartment}
                            isDisabled={accTransloading || vendorLoading}
                            placeholder="Filter Department"
                            onChange={(e) => {
                              setSearchDepartment(e);
                            }}
                            options={departmentList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchBranch"
                            value={searchBudget}
                            placeholder="Filter Anggaran"
                            isDisabled={accTransloading || vendorLoading}
                            onChange={(e) => {
                              toggleTab(e.value, "budget");
                              setSearchBudget(e);
                            }}
                            options={civilBudgetTypeList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}>
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}>
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card table-container-sticky mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-fixed-header table-nowrap">
                      <thead>
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        <tr className="bg-light">
                          <th></th>
                          <th colSpan={2}>
                            Total <em className="fs-11 text-muted fw-normal"></em>
                          </th>
                          <th className="text-info"></th>
                          <th className="text-info fs-15">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.payable || 0)), 0))}</th>
                          <th className="text-success fs-15">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.cash || 0)), 0))}</th>
                          <th className="text-primary fs-15">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.original.total || 0)), 0))}</th>
                        </tr>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    DETAIL TRANSAKSI {label}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody className="pb-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-grow-1">
                          <input className="search-box form-control" style={{ maxWidth: "320px" }} placeholder="Filter Data..." onChange={(e) => searchList(e.target.value)} />
                        </div>
                        <div className="flex-shrink-0">
                          <ExportDoc data={printMaterialDoc} />
                        </div>
                      </div>
                      <div>
                        <SimpleBar style={{ height: "520px" }}>
                          <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                            <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                              <tr className="bg-soft-info">
                                <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => {
                                        return {
                                          ...item,
                                          isChecked: !allChecked,
                                        };
                                      });
                                      setExpense(updatedData);
                                    }}
                                  />
                                </td>
                                <td className="text-start">Kontak / Supplier</td>
                                <td style={{ width: "40px" }}></td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tanggal
                                </td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  Jenis
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Terbayar
                                </td>
                                <td className="text-center">Keterangan</td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || [])
                                .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
                                .map((o, i) => {
                                  return (
                                    <Fragment key={i}>
                                      <tr className="product bg-light">
                                        <td className="product-id">
                                          <input
                                            type="checkbox"
                                            className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                            checked={o.isChecked}
                                            onChange={() => {
                                              const updatedData = expense.map((d) => {
                                                return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                              });

                                              setExpense(updatedData);
                                            }}
                                          />{" "}
                                          {i + 1}
                                        </td>
                                        <td className="text-start fw-semibold">{o.name || "NO NAME"}</td>
                                        <td className="text-center fw-semibold">{o.branch}</td>
                                        <td className="text-center">{o.transaction_no}</td>
                                        <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                        <td className="text-center">{o.type}</td>
                                        <td className={"text-center fw-semibold"}>{currencyFormat(parseFloat(o.total ?? 0))}</td>
                                        <td className="text-start">{o.description}</td>
                                      </tr>
                                      {((o.file || []).length > 0) && (
                                        <tr>
                                          <td></td>
                                          <td colSpan={10} className="pe-0">
                                            <Accordion className="p-0 w-100 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                                              {(o.file || []).length > 0 && (
                                                <AccordionItem className="border-0">
                                                  <div
                                                    className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i + 10000 ? false : true })}
                                                    onClick={() => {
                                                      toggleActiveAccordion(i + 10000);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                  >
                                                    <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                                      Bukti Transaksi
                                                    </div>
                                                  </div>
                                                  <Collapse isOpen={activeAccordion === i + 10000 ? true : false} className="accordion-collapse bg-light border-0">
                                                    <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                                      {(o.file || []).map((f, ii) => {
                                                        let type;
                                                        return (
                                                          <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                              <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                                            ) : (
                                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                              </Link>
                                                            )}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </Collapse>
                                                </AccordionItem>
                                              )}
                                            </Accordion>
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>
                                  );
                                })}
                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="11" className="p-3 text-center">
                                    Belum ada data
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {info?.material_name ?? ""}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody>
                      <div>
                        <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                          <div className="col-sm-10">
                            <Row className="m-0 p-0 ">
                              <div className="fw-semibold  text-start">
                                <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                              </div>
                            </Row>
                          </div>
                          <div className="col-sm-2 text-end">
                            <ExportDoc data={printDetailDoc} />
                          </div>
                        </Row>
                        <SimpleBar className="table-container-sticky">
                          <Table className="table-border text-center table-hover table-fixed-header">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => ({
                                        ...item,
                                        isChecked: !allChecked,
                                      }));
                                      setExpense(updatedData);
                                    }}
                                  />
                                </th>
                                <th className="text-center" style={{ width: "100px" }}>
                                  No Transaksi
                                </th>
                                <th className="text-center" style={{ width: "80px" }}>
                                  Tanggal
                                </th>
                                <th className="text-center" style={{ width: "80px" }}>
                                  Jenis
                                </th>
                                <th className="text-right" style={{ width: "170px" }}>
                                  Tag
                                </th>
                                <th className="text-right" style={{ width: "170px" }}>
                                  Jumlah
                                </th>
                                <th className="text-center" style={{ width: "200px" }}>
                                  Keterangan
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || []).sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat)).map((o, i) => {
                                let type;
                                switch (o.type) {
                                  case "CASH IN":
                                    type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                                    break;
                                  case "RECEIVABLE":
                                    type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                                    break;
                                  case "CASH OUT":
                                    type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                                    break;
                                  case "PAYABLE":
                                    type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                                    break;
                                  default:
                                    type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                                    break;
                                }
                                return (
                                  // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                                  <tr key={i}>
                                    <td style={{ verticalAlign: "middle", width: "30px" }}>
                                      <div className="hstack gap-2 mt-4 mt-sm-0">
                                        <input
                                          type="checkbox"
                                          className="checkboxDetail me-2 form-check-input"
                                          checked={o.isChecked}
                                          onChange={() => {
                                            const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                            setExpense(updatedData);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {o.transaction_no}
                                      {o.statusId === 4 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                        </p>
                                      )}
                                      {o.statusId === 3 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                        </p>
                                      )}
                                      {o.statusId === 2 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                        </p>
                                      )}
                                      {o.statusId === 1 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                        </p>
                                      )}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {handleValidDate(o.transactionat)}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {type}
                                    </td>
                                    <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                      {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {currencyFormat(o.amount)}
                                    </td>
                                    <td className="text-left" style={{ verticalAlign: "middle" }}>
                                      {o.description}
                                    </td>
                                  </tr>
                                );
                              })}

                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="7" className="p-3 text-center">
                                    Belum ada realisasi
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                        <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                          <div className="col-sm-6 fs-12 text-start">
                            PEMBAYARAN KAS / BANK:
                            <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                              {currencyFormat(
                                (expense || [])
                                  .filter((el) => el.type === "CASH OUT" && (el.statusId === 3))
                                  .map((el) => parseFloat(el.amount || 0))
                                  .reduce((prev, curr) => prev + curr, 0)
                              )}
                            </span>
                          </div>
                        </Row>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div >
  );
};

export default Purchase;
